import {Controller} from "stimulus"

export default class extends Controller {

    connect() {
    }

    updateReport(e) {
        const reportYear = document.getElementById("year")
        const reportMonth = document.getElementById("month")
        const jurisdiction = document.getElementById("jurisdiction_id");
        let reportUrl = 'monthly?year=' + reportYear.value + '&month=' + reportMonth.value;
        if (jurisdiction != null && jurisdiction.value !== '') {
            reportUrl = reportUrl + '&jurisdiction_id=' + encodeURIComponent(jurisdiction.value)
        }
        window.location.href = reportUrl
    }
}
